module.exports = __webpack_public_path__ + "static/media/logo_compra_pyme.0b14837f.svg";